// extracted by mini-css-extract-plugin
export default {"pdvContainer":"pdv_pdvContainer__14SS3"};